var exports = {
  "Zd": "x31de4314--1c5c80--form",
  "s7": "x31de4314--1c5c80--field--main",
  "qY": "x31de4314--1c5c80--license",
  "iZ": "x31de4314--1c5c80--message--succeed",
};

module.exports = exports;
